(() => {
  const html = document.documentElement;
  let prevHtmlOverflow = '';
  let locked = false;

  const isOpen = () => {
    const quiz = document.querySelector('#octane-quiz-outer-wrapper');
    return quiz && quiz.offsetParent !== null;
  };

  const sync = () => {
    if (isOpen()) {
      if (!locked) {
        prevHtmlOverflow = html.style.overflow;
        html.style.overflow = 'hidden';
        locked = true;
      }
    } else if (locked) {
      html.style.overflow = prevHtmlOverflow;
      locked = false;
    }
  };

  const nativeScrollTo = window.scrollTo.bind(window);
  window.scrollTo = function (...args) {
    if (!isOpen()) {
      return nativeScrollTo(...args);
    }
  };

  new MutationObserver(sync).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'hidden'],
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') requestAnimationFrame(sync);
  });

  sync();
})();